import { Injectable } from '@angular/core';
import { AudienceService } from '../audience/audience.service';
import {
  AttributeEnumValuesResponse,
  CountInfo
} from '../models/criteria-type';
import { BehaviorSubject } from 'rxjs';
import { AudienceBuilderService } from '../audience-builder/audience-builder.service';

@Injectable()
export class CriteriaService {
  contextId: string;
  dataUniverseId: string;

  public countDetailsUpdate = new BehaviorSubject<CountInfo>({
    totalIncludecount: undefined,
    totalExcludeCount: undefined,
    includeGroupCounts: undefined
  });

  constructor(
    private audienceService: AudienceService,
    private audienceBuilderService: AudienceBuilderService
  ) {}

  updateAPIParams = (contextId: string, dataUniverseId: string) => {
    this.contextId = contextId;
    this.dataUniverseId = dataUniverseId;
  };

  getAttributeEnumValues = (
    entityEnumId
  ): Promise<AttributeEnumValuesResponse> => {
    return new Promise((resolve, reject) => {
      this.audienceService
        .getEnumValues(this.contextId, entityEnumId)
        .subscribe({
          next: (response: AttributeEnumValuesResponse) => {
            return resolve(response);
          },
          error: (e) => {
            console.log(e);
            return reject(e);
          }
        });
    });
  };

  fetchAttributeDetails = (attributeType, attributeId) => {
    return this.audienceBuilderService.fetchCabAttributeDetails(
      attributeType,
      this.contextId,
      this.dataUniverseId,
      attributeId
    );
  };

  fetchAudienceBuilderSqlQuery(cabId: string, queryType: string) {
    return this.audienceService.fetchAudienceBuilderSqlQuery(
      this.contextId,
      cabId,
      queryType
    );
  }
}
